import _skills from "../assets/json/skills.json";
import _trainers from "../assets/json/trainers.json";
import _events from "../assets/json/events.json";
import ISkill from "../types/Skill";
import ITrainer from "../types/Trainer";

type JsonSkills = typeof _skills;
export type SkillNames = keyof JsonSkills;

export const jsonSkills = _skills as { [key in SkillNames]: ISkill };

export const jsonTrainers = (_trainers.map((trainer) => ({
  ...trainer,
  level: 1,
})) as unknown) as ITrainer[];

export const jsonEvents = _events;
